import { useState } from 'react';
import { Card } from '../../../../components/atoms';
import { FeesTab } from './Tabs/FeesTab';
import { JuridictionsTab } from './Tabs/JuridictionsTab';
import { AddonsTab } from './Tabs/AddonsTab';
import { DirectorsAndShareholdersTab } from './Tabs/DirectorsAndShareholdersTab';
import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';
import { useTranslation } from 'react-i18next';

const ConfigurationOnboarding = () => {
  const [activeTab, setActiveTab] = useState<'fees' | 'addons' | 'directors' | 'jurisdictions'>('fees');
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const { t } = useTranslation()
  const tabs = [
    { key: 'fees', label: t('config.TabFees')},
    { key: 'addons', label: t('config.TabAddons') },
    { key: 'directors', label: t('config.TabDirectors') },
    { key: 'jurisdictions', label: t('config.TabJurisdictions') }

  ];

  type TabKey = 'fees' | 'addons' | 'directors' | 'jurisdictions';

  const tabComponents: Record<TabKey, JSX.Element> = {
    fees: <FeesTab />,
    addons: <AddonsTab />,
    directors: <DirectorsAndShareholdersTab />,
    jurisdictions: <JuridictionsTab />
  };

  return (
    <Card.Root className="w-full">
      <Card.Header>
        <h3 className="text-lg font-medium">{t('titles.ttlCustomizeMyPlatform')}</h3>
      </Card.Header>

      <Card.Content>
        <div className="w-full flex flex-col">
          <div className="flex gap-6 border-b mb-4 ">
            {tabs.map(tab => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key as typeof activeTab)}
                className="pb-2 font-medium"
                style={{
                  color: activeTab === tab.key ? colors.primary : '#4b5563',
                  borderBottom: activeTab === tab.key ? `2px solid ${colors.primary}` : '2px solid transparent'
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="pt-4">
            {tabComponents[activeTab]}
          </div>
        </div>
      </Card.Content>
    </Card.Root>
  );
};

export { ConfigurationOnboarding };
